function fillNumber (number) {
  return String(number).length === 1 ? `0${number}` : number
}

export function getTodayDate (dateObj) {
  if (dateObj) {
    return `${fillNumber(dateObj.getFullYear())}-${fillNumber(dateObj.getMonth() + 1)}-${fillNumber(
      dateObj.getDate()
    )}`
  }
  let year = new Date().getFullYear()
  let month = new Date().getMonth() + 1

  let date = new Date().getDate()
  return `${fillNumber(year)}-${fillNumber(month)}-${fillNumber(date)}`
}
